import { useIntl } from 'react-intl';
import OverlayTrigger from '@rio-cloud/rio-uikit/OverlayTrigger';
import Popover from '@rio-cloud/rio-uikit/Popover';

import { sendTyreDetailToParent } from '@/features/app/MessageHandler';
import { TyreReading } from '@/generated/GeneratedApiTypes';
import TyreDetail from './TyreDetail';
import { formatAxleSide } from './utils';

interface TyrePopoverProps {
    tyre?: TyreReading;
    axleLabel: string;
    assetId: string;
    side: string;
    children: React.ReactElement;
}

const TyrePopover = ({ assetId, tyre, axleLabel, side, children }: TyrePopoverProps) => {
    const intl = useIntl();

    const axleSide = tyre?.axle_side ?? side;
    const axlePosition = tyre?.axle_position ?? '';
    const axleTitle =
        `${intl.formatMessage({ id: 'intl-msg:tyres.axle' })}` + ` ${axleLabel}: ${formatAxleSide(axleSide, intl)}`;

    const handleMobileClick = () => {
        const detailPath = `/tyre-detail/${assetId}/${axlePosition}/${axleSide}`;
        sendTyreDetailToParent(axleTitle, detailPath);
    };

    const overlay = (
        <Popover
            id={`popover-${axleLabel}-${axleSide}`}
            title={axleTitle}
            titleClassName="text-size-16 text-medium border-none padding-bottom-0"
            className="max-width-250"
        >
            <Popover.Content className="min-width-250">
                <TyreDetail tyre={tyre} />
            </Popover.Content>
        </Popover>
    );

    return (
        <>
            {/* Desktop: hover popover */}
            <span className="hidden-xs">
                <OverlayTrigger trigger="hover" placement="bottom" delay={{ show: 100, hide: 0 }} overlay={overlay}>
                    {children}
                </OverlayTrigger>
            </span>
            {/* Mobile: click sends postMessage to parent */}
            <span className="visible-xs" onClick={handleMobileClick}>
                {children}
            </span>
        </>
    );
};

export default TyrePopover;
